var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:[
        _vm.bgColor ? '' : 'c-tag--' + _vm.color,
        'c-tag--' + _vm.type,
        'c-tag',
        _vm.hoverColor ? 'c-tag-hover--' + _vm.hoverColor : ''
    ],style:([
        { 'background-color': _vm.bgColor },
        _vm.type === 'circle'
            ? {
                  width: _vm.size + 'px',
                  height: _vm.size + 'px',
                  'line-height': _vm.size + 'px'
              }
            : ''
    ])},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }